import {settings} from "../config.ts";
import axios from "axios";

export async function getLeaderboard(userId: string) {
    const config = {
        headers: {
            Authorization: `Bearer ${encodeURIComponent(userId)}`,
        },
    };
    try {
        const url = `${settings.url}leaderboard`;

        const response = await axios.get(url, config)

        return response.data;
    } catch (e) {
        console.log("Ошибка", e)
    }
}